/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import BindContext from '../../../context/BindProvider';
import { setStorage, getStorage } from '../../../helpers/general';
import Head from '../../atoms/Head/Head';
import Footer from '../Footer/v2/Footer';
import Header from '../Header/v2/Header';
// CSS not modular here to provide global styles
import { useLocation } from '@reach/router';
import SimpleFooter from '../../atoms/SimpleLayouts/SimpleFooter';
import SimpleHeader from '../../atoms/SimpleLayouts/SimpleHeader';
import './Layout.css';
import * as styles from './Layout.module.css';
import queryString from 'query-string';
import useSegment from 'hooks/useSegment';
import { Helmet } from 'react-helmet';
import favIconPc from '../../../../static/favicon.ico';
import JoinClubModal from '../../molecules/JoinClubModal/JoinClubModal';
import Sidebar from '../../molecules/JoinClubSidebar/JoinClubSidebar';

const simpleLayout = ['confirm-order', 'checkout', 'order-confirmation'];
const Layout = ({ children, className, slim = false, disablePaddingBottom = false }) => {
  const { pathname, search } = useLocation();

  const { identifyManual } = useSegment();
  const bind = useContext(BindContext);
  const initBind = bind && bind.init;

  const [showLightbox, setShowLightbox] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);

  useEffect(() => {
    const delay = 2000;
    const timeoutId = setTimeout(() => {
      const parsed = queryString.parse(search);
      if (typeof window !== 'undefined' && window.gtag && parsed.gclid) {
        window.gtag('get', 'G-XXXXXX', 'client_id', function (clientId) {
          identifyManual({
            gclid: parsed.gclid,
            gacid: clientId
          });
        });
      }
    }, delay);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  useEffect(() => {
    const currentDate = new Date().getTime();
    const isExpired = parseInt(getStorage('clubExpiryDate')) < currentDate;
    let isNewUser = getStorage('isClubNewUser') === null;
    const isNotSubmitted = getStorage('isClubSubmitted') === null;
    const isTargetUrl = !['/checkout', '/pet-chemist-club', '/pet-chemist-club-stg'].includes(
      window.location.pathname.replace(/\/$/, '')
    );
    if (window.location.href.includes('staging--petchemist')) {
      isNewUser = false;
    }
    if (isTargetUrl && isNotSubmitted && (isExpired || isNewUser)) {
      setShowLightbox(true);

      const expiryDaysinMs = 90 * 24 * 60 * 60 * 1000; // 90 Days
      const expiryDate = currentDate + expiryDaysinMs;

      setStorage('isClubNewUser', 'false', false);
      setStorage('clubExpiryDate', expiryDate.toString(), false);
    }
  }, []);

  const handleCloseLightbox = () => {
    setShowLightbox(false);
    setShowSidebar(true);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };

  const handleOpenSidebar = (isOpen) => {
    if (!showLightbox) {
      setShowLightbox(isOpen);
      setShowSidebar(!isOpen);
    }
  };

  const data = {
    site: {
      siteMetadata: {
        title: 'Pet Chemist'
      }
    }
  };

  if (
    typeof window !== 'undefined' &&
    ['/login', '/login/', '/signup', '/signup/', '/forgotpassword', '/forgotpassword/'].indexOf(
      window.location.pathname
    ) === -1
  ) {
    setStorage('lastPage', window.location.href, true);
  }

  const messages = [{ text: 'This is a hardcoded example message', link: '/shop/shop-all' }];

  useEffect(() => {
    initBind();
  }, [initBind]);

  useEffect(() => {
    async function importCSS() {
      await import('./Globals.css');
    }

    importCSS();
  }, []);

  return (
    <>
      <script
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                                                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                                                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                                                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                                              })(window,document,'script','dataLayer','AW-882086929');`
        }}
      />
      <Head>
        <link rel="canonical" href={process.env.SITE_URL + pathname} />
      </Head>
      <Helmet link={[{ rel: 'icon', type: 'image/ico', href: favIconPc }]}></Helmet>

      {simpleLayout.includes(pathname.replace(/\//g, '')) ? (
        <SimpleHeader />
      ) : (
        <Header siteTitle={data.site.siteMetadata?.title || `Title`} messages={messages} />
      )}

      <JoinClubModal
        show={showLightbox}
        handleClose={handleCloseLightbox}
        handleSidebarClose={handleSidebarClose}
      />
      {!showLightbox && <Sidebar show={showSidebar} handleOpen={handleOpenSidebar} />}

      <main
        className={`${styles.main} ${className} ${
          disablePaddingBottom === true ? styles.disablePaddingBottom : ''
        }`}
      >
        {children}
      </main>

      {simpleLayout.includes(pathname.replace(/\//g, '')) ? <SimpleFooter /> : <Footer />}
    </>
  );
};

export default Layout;
